module.exports = __webpack_public_path__ + "img/two-f-r.fb75ba5f.png";